import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Section } from './ui/Section';
const forWho = ['Solopreneurs y freelancers con clientes reales que ya no tienen agenda disponible.', 'Dueños de agencias o servicios digitales que quieren escalar sin contratar más personal.', 'Profesionales +35 que valoran su tiempo tanto como su rentabilidad.', 'Personas que odian la tecnología compleja pero entienden que deben actualizarse o quedar obsoletos.'];
const notForWho = ["Personas que buscan 'dinero mágico' sin tener un negocio o servicio real.", 'Quienes no están dispuestos a dedicar 2 horas a configurar sus sistemas por única vez.', 'Perfiles que prefieren delegar todo en empleados sin entender cómo funciona su propio motor de ventas.'];
export function AudienceSection() {
  return <Section className="px-6 md:px-12 max-w-6xl mx-auto border-t border-[#d4a853]/10" data-id="element-1">
      <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-2">
        {/* Para quién ES */}
        <div className="space-y-8" data-id="element-3">
          <h3 className="font-serif text-2xl md:text-3xl font-semibold text-gray-100 flex items-center" data-id="element-4">
            <span className="w-8 h-[1px] bg-[#d4a853] mr-4 block" data-id="element-5" />
            Para quién ES
          </h3>
          <ul className="space-y-6" data-id="element-6">
            {forWho.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start space-x-4" data-id="element-7">
                <Check className="w-5 h-5 text-[#d4a853] mt-1 flex-shrink-0" strokeWidth={2} data-id="element-8" />
                <span className="font-sans text-gray-300 leading-relaxed" data-id="element-9">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>

        {/* Para quién NO ES */}
        <div className="space-y-8 md:pl-8 md:border-l border-gray-800" data-id="element-10">
          <h3 className="font-serif text-2xl md:text-3xl font-semibold text-gray-500 flex items-center" data-id="element-11">
            <span className="w-8 h-[1px] bg-gray-700 mr-4 block" data-id="element-12" />
            Para quién NO ES
          </h3>
          <ul className="space-y-6" data-id="element-13">
            {notForWho.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start space-x-4" data-id="element-14">
                <X className="w-5 h-5 text-gray-600 mt-1 flex-shrink-0" strokeWidth={2} data-id="element-15" />
                <span className="font-sans text-gray-500 leading-relaxed" data-id="element-16">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </Section>;
}